import React from "react";
import PropTypes from "prop-types";
import DataGrid, { DataGridItem } from "components/data-grid";
import LocalRecordingsPaginatedTable from "../../../components/common/local-recordings-table/table";

const LocalRecordingsData = ({ clipPage, event }) => {

    return (
      <DataGrid>
        <DataGridItem big>
          <LocalRecordingsPaginatedTable page={clipPage} pageName={"clipPage"} variables={{ eventId: event.id, eventTitle: event.title }} />
        </DataGridItem>
      </DataGrid>
    );
};

LocalRecordingsData.propTypes = {
  /**
   * Page of table
   **/
  page: PropTypes.number,
  /**
   * Data to represent
   **/
  event: PropTypes.object,
};

export default LocalRecordingsData;
